//import { set } from '@/utils/vuex'
import lookupService from '@/services/lookupService'
import axios from '@/plugins/axios'

function getLookup (state, prop, lookupName) {
    if (!state[prop]) {
        lookupService.listLookup(axios, lookupName).then(response => {
            state[prop] = response.data
            return state[prop]
        })
    } else {
        return state[prop]
    }
}

const state = {
    countyList: null,
    eventTypeList: null,
    facilityTypeList: null
}

const getters = {
    countyList: state => {
        return getLookup(state, 'countyList', 'County')
    },
    eventTypeList: state => {
        return getLookup(state, 'eventTypeList', 'EventType')
    },
    facilityTypeList: state => {
        return getLookup(state, 'facilityTypeList', 'FacilityType')
    }
}

const mutations = {}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
